'use strict';

yalwa.continent = (function (pub) {
	pub = pub || {};

	pub.init = function() {
		if (yalwa.v.region) {
			google.load('visualization', '1', {packages: ['geochart'], callback: draw});
		}
		jQuery(window).on('resize', () => {
			yalwa.basics.debounce(draw, 400);
		});
	};

	function draw() {
		if (typeof google.visualization === 'undefined') {
			return false;
		}
		const geochart = new google.visualization.GeoChart(jQuery('.js-geochart')[0]);
		google.visualization.events.addListener(geochart, 'select', function() {
			yalwa.basics.navigate(yalwa.v.country_links[geochart.getSelection()[0].row]);
		});
		geochart.draw(google.visualization.arrayToDataTable(yalwa.v.country_codes), {
			backgroundColor: {
				stroke: '#000000',
				strokeWidth: 0
			},
			projection: 'kavrayskiy-vii',
			colorAxis: {colors: ['#ffeecc']},
			region: yalwa.v.region,
			legend: 'none'
		});

	}

	return pub;
	
})(yalwa.continent);

yalwa.continent.init();